import type { Resource } from '../../';
export const header_utilBar_accountIconAltText: Resource = {"default":"User Menu"};
